export const security = {
  'if-you-donot-have-patranomic': 'Егер әкеңіздің аты болмаса, сызықша қойыңыз',
  citizenship: 'Азаматтық',
  'email-results': 'Тексеру нәтижелері бойынша поштаңызға <strong>{userEmail}</strong> хат жіберіледі',
  'store-manager': 'Дүкен директоры',
  'security-questionnaire': 'Ішкі сауалнама',
  'acceptable-formats': 'Жарамды форматтар — .jpeg, .jpg, .png, .pdf',
  'download-file-before-sending': 'Жібермес бұрын файл(дарды) жүктеңіз',
  'field-too-long': 'Максималды ұзындығы — 255 таңба',
};
